module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Light-a2a03b5e51caf950b1981d98afff2f54.eot";